export const getAppName = (isClickCollect = false) => (isClickCollect ? 'CLICKCOLLECT' : 'QRMENU')
